(function () {
  const SELECTOR = "[data-multilikes-favorite]";
  const DEFAULT_ENDPOINT = "/apps/multilikes-endpoint";
  const DEFAULT_LOGIN_URL = "/account/login";
  const DEFAULT_REGISTER_URL = "/account/register";
  const DEFAULT_LOGIN_TITLE = "お気に入り登録にはログインが必要です";
  const DEFAULT_LOGIN_BODY = "NOSE SHOPにログインすると、気になる商品をお気に入りに保存できます。無料の会員登録で、マイページからいつでも見返せます。";
  const DEFAULT_LOGIN_LABEL = "ログイン";
  const DEFAULT_REGISTER_LABEL = "会員登録";

  let loginModal = null;
  let loginModalLastFocused = null;
  let loginModalWasLocked = false;
  let isLoginModalOpen = false;

  if (window.MultiLikesFavorite) {
    window.MultiLikesFavorite.init();
    return;
  }

  // 状態は MultiLikes に問い合わせず、layout が顧客メタフィールドから埋め込んだ値で判定する。
  // 状態の GET はボタンの数だけアプリに負荷をかけ、大型販売で 429 になる（鹿島アントラーズ EC 2026-10-01）。
  const config = window.MultiLikesConfig || {};
  const wishlistVariantIds = new Set(Array.isArray(config.wishlistVariantIds) ? config.wishlistVariantIds.map(String) : []);

  let hasWarnedMissingIds = false;

  // 埋め込みが無いと全ボタンが未登録に見える。過負荷の経路を残さないため GET へは戻さない。
  // layout ごと消えた場合も気付けるよう、会員かどうかはボタン側の customerId で見る
  function warnIfIdsMissing(root) {
    if (!hasWarnedMissingIds && root.dataset.customerId && !Array.isArray(config.wishlistVariantIds)) {
      hasWarnedMissingIds = true;
      console.warn("MultiLikes: wishlistVariantIds is missing, so every button shows as not in the wishlist.");
    }
  }

  function setWishlisted(variantId, isInWishlist) {
    if (isInWishlist) {
      wishlistVariantIds.add(String(variantId));
    } else {
      wishlistVariantIds.delete(String(variantId));
    }
  }

  // 追加・解除の結果を、しばらく手元にも残して埋め込み値より優先する。
  // 戻る操作でキャッシュのページが出たとき、その埋め込み値は古いため。
  // 引き換えに、ほかの端末での変更はこの間だけ隠れる。キーと形は multilikes-wishlist-page.js と共通
  const RECENT_CHANGES_KEY = "multilikes:recent-changes";
  const RECENT_CHANGES_TTL = 10 * 60 * 1000;

  function storeRecentChanges(changes) {
    try {
      if (Object.keys(changes).length) {
        window.localStorage.setItem(RECENT_CHANGES_KEY, JSON.stringify({ customerId: config.customerId, changes }));
      } else {
        window.localStorage.removeItem(RECENT_CHANGES_KEY);
      }
    } catch (error) {
      // 保存できなくても、表示は埋め込み値で続ける
    }
  }

  // ログイン中のお客様の、期限内の記録だけを返す
  function readRecentChanges() {
    const changes = {};
    const now = Date.now();
    let stored = null;

    try {
      stored = JSON.parse(window.localStorage.getItem(RECENT_CHANGES_KEY));
    } catch (error) {
      stored = null;
    }

    if (!stored || !stored.changes || typeof stored.changes !== "object" || stored.customerId !== config.customerId) {
      return changes;
    }

    Object.keys(stored.changes).forEach((variantId) => {
      const change = stored.changes[variantId];
      const age = change ? now - change.at : NaN;

      // 端末の時計が戻されると未来の時刻が残り続けるので、負の経過時間も期限切れにする
      if (age >= 0 && age < RECENT_CHANGES_TTL) {
        changes[variantId] = change;
      }
    });

    return changes;
  }

  function rememberChange(variantId, isInWishlist) {
    const changes = readRecentChanges();

    changes[variantId] = { inWishlist: isInWishlist, at: Date.now() };
    storeRecentChanges(changes);
  }

  function applyRecentChanges() {
    const changes = readRecentChanges();

    Object.keys(changes).forEach((variantId) => {
      setWishlisted(variantId, changes[variantId].inWishlist === true);
    });

    // 期限切れと、ほかのお客様の記録はここで消える
    storeRecentChanges(changes);
  }

  if (config.customerId) {
    applyRecentChanges();
  } else {
    // ログアウトしたら、前のお客様の記録を端末に残さない
    storeRecentChanges({});
  }

  function getData(payload) {
    if (!payload || typeof payload !== "object") {
      return {};
    }

    return payload.data && typeof payload.data === "object" ? payload.data : payload;
  }

  function getIsInWishlist(data) {
    const value = data.isInWishlist;

    return value === true || value === "true" || value === 1 || value === "1";
  }

  function getEndpoint(root) {
    return root.dataset.endpoint || DEFAULT_ENDPOINT;
  }

  function getProductVariantId(root) {
    const form = root.closest("form");

    if (form) {
      const variantInput = form.querySelector('[name="id"]');

      if (variantInput && variantInput.value) {
        return variantInput.value;
      }
    }

    const productSection = root.closest('[data-section-type="product"], [data-section-type="featured-product"]');
    const sectionVariantInput = productSection && productSection.querySelector('form [name="id"]');

    if (sectionVariantInput && sectionVariantInput.value) {
      return sectionVariantInput.value;
    }

    return root.dataset.variantId || "";
  }

  function buildPostParams(root, action, variantId) {
    const params = new URLSearchParams();

    params.set("target_type", "product");
    params.set("customer_id", root.dataset.customerId);
    params.set("product_id", root.dataset.productId);
    params.set("variant_id", variantId);
    params.set("action", action);

    return params;
  }

  function setLoading(root, isLoading) {
    const button = root.querySelector("[data-multilikes-toggle]");
    const loadingIcon = root.querySelector("[data-multilikes-loading]");

    root.classList.toggle("is-loading", isLoading);

    if (button) {
      button.classList.toggle("is-loading", isLoading);
      button.disabled = isLoading;
    }

    if (loadingIcon) {
      loadingIcon.hidden = !isLoading;
    }
  }

  function updateState(root, isInWishlist) {
    const button = root.querySelector("[data-multilikes-toggle]");
    const labelElement = root.querySelector("[data-multilikes-label]");
    const label = isInWishlist ? root.dataset.removeLabel : root.dataset.addLabel;

    root.classList.toggle("is-active", isInWishlist);
    if (button) {
      button.classList.toggle("is-active", isInWishlist);
      button.dataset.active = isInWishlist ? "true" : "false";
      button.setAttribute("aria-pressed", isInWishlist ? "true" : "false");
      button.setAttribute("aria-label", label);
    }

    if (labelElement) {
      labelElement.textContent = label;
    }
  }

  async function requestJson(url, options) {
    const response = await fetch(url, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        ...(options && options.headers ? options.headers : {}),
      },
      ...options,
    });

    if (!response.ok) {
      throw new Error(`MultiLikes request failed: ${response.status}`);
    }

    return response.json();
  }

  // 判定は「ボタンのバリエーションIDが埋め込みの配列に入っているか」だけ。通信はしない
  function refresh(root, options) {
    const variantId = options && options.variantId ? String(options.variantId) : getProductVariantId(root);

    if (variantId) {
      root.dataset.variantId = variantId;
    }

    updateState(root, Boolean(config.customerId && variantId && wishlistVariantIds.has(String(variantId))));
  }

  function refreshAll() {
    document.querySelectorAll(SELECTOR).forEach((root) => refresh(root));
  }

  function getFocusableElements(element) {
    return Array.from(element.querySelectorAll([
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])",
    ].join(",")));
  }

  function createLoginModal() {
    const modal = document.createElement("div");
    modal.className = "multilikes-login-modal";
    modal.setAttribute("aria-hidden", "true");
    modal.hidden = true;
    modal.innerHTML = `
      <div class="multilikes-login-modal__overlay" data-multilikes-login-close></div>
      <div class="multilikes-login-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="multilikes-login-modal-title" aria-describedby="multilikes-login-modal-description" tabindex="-1">
        <button type="button" class="multilikes-login-modal__close" data-multilikes-login-close aria-label="閉じる">
          <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false">
            <path d="M1 1l16 16M17 1L1 17" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
        <p class="multilikes-login-modal__eyebrow">WISHLIST</p>
        <h2 class="multilikes-login-modal__title" id="multilikes-login-modal-title"></h2>
        <p class="multilikes-login-modal__description" id="multilikes-login-modal-description"></p>
        <div class="multilikes-login-modal__actions">
          <a class="multilikes-login-modal__button multilikes-login-modal__button--primary" data-multilikes-login-link></a>
          <a class="multilikes-login-modal__button multilikes-login-modal__button--secondary" data-multilikes-register-link></a>
        </div>
      </div>
    `;

    modal.addEventListener("click", (event) => {
      if (event.target.closest("[data-multilikes-login-close]")) {
        closeLoginModal();
      }
    });

    document.body.appendChild(modal);

    return modal;
  }

  function ensureLoginModal() {
    if (!loginModal) {
      loginModal = createLoginModal();
    }

    return loginModal;
  }

  function handleLoginModalKeydown(event) {
    if (!isLoginModalOpen || !loginModal) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeLoginModal();
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const dialog = loginModal.querySelector(".multilikes-login-modal__dialog");
    const focusableElements = dialog ? getFocusableElements(dialog) : [];

    if (!dialog || focusableElements.length === 0) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function closeLoginModal() {
    if (!isLoginModalOpen || !loginModal) {
      return;
    }

    isLoginModalOpen = false;
    loginModal.setAttribute("aria-hidden", "true");
    document.removeEventListener("keydown", handleLoginModalKeydown);

    if (!loginModalWasLocked) {
      document.documentElement.classList.remove("no-scroll");
    }

    window.setTimeout(() => {
      if (!isLoginModalOpen && loginModal) {
        loginModal.hidden = true;
      }
    }, 260);

    if (loginModalLastFocused && typeof loginModalLastFocused.focus === "function") {
      loginModalLastFocused.focus({ preventScroll: true });
    }
  }

  function showLoginModal(root) {
    const modal = ensureLoginModal();
    const title = modal.querySelector("#multilikes-login-modal-title");
    const description = modal.querySelector("#multilikes-login-modal-description");
    const loginLink = modal.querySelector("[data-multilikes-login-link]");
    const registerLink = modal.querySelector("[data-multilikes-register-link]");
    const dialog = modal.querySelector(".multilikes-login-modal__dialog");

    if (title) {
      title.textContent = root.dataset.loginTitle || DEFAULT_LOGIN_TITLE;
    }

    if (description) {
      description.textContent = root.dataset.loginBody || DEFAULT_LOGIN_BODY;
    }

    if (loginLink) {
      loginLink.href = root.dataset.loginUrl || DEFAULT_LOGIN_URL;
      loginLink.textContent = root.dataset.loginLabel || DEFAULT_LOGIN_LABEL;
    }

    if (registerLink) {
      registerLink.href = root.dataset.registerUrl || DEFAULT_REGISTER_URL;
      registerLink.textContent = root.dataset.registerLabel || DEFAULT_REGISTER_LABEL;
    }

    if (!isLoginModalOpen) {
      loginModalLastFocused = document.activeElement;
      loginModalWasLocked = document.documentElement.classList.contains("no-scroll");
      document.addEventListener("keydown", handleLoginModalKeydown);
    }

    modal.hidden = false;
    isLoginModalOpen = true;

    window.requestAnimationFrame(() => {
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("no-scroll");

      if (dialog) {
        dialog.focus({ preventScroll: true });
      }
    });
  }

  async function toggle(root) {
    if (!root.dataset.customerId) {
      showLoginModal(root);
      return;
    }

    const button = root.querySelector("[data-multilikes-toggle]");
    const action = button && button.dataset.active === "true" ? "remove" : "add";
    const variantId = getProductVariantId(root);

    if (!variantId) {
      console.error("MultiLikes: variant id is missing, so the favorite cannot be updated.");
      return;
    }

    const params = buildPostParams(root, action, variantId);
    // 同じバリエーションのボタン（商品フォームと追従バー）を通信中は全部止め、二重の追加・解除を防ぐ
    const sameVariantRoots = Array.from(document.querySelectorAll(SELECTOR)).filter((candidate) => getProductVariantId(candidate) === variantId);

    sameVariantRoots.forEach((candidate) => setLoading(candidate, true));

    try {
      const payload = await requestJson(getEndpoint(root), {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: params.toString(),
      });
      const data = getData(payload);
      // 応答に isInWishlist が無ければ、送った操作の結果とみなす
      const isInWishlist = data.isInWishlist === undefined ? action === "add" : getIsInWishlist(data);

      setWishlisted(variantId, isInWishlist);
      rememberChange(variantId, isInWishlist);
      // 同じバリエーションのボタンが複数あっても揃える。通信中にバリエーションが変わったボタンは、今のバリエーションで塗り直る
      refreshAll();
    } catch (error) {
      console.error(error);
      window.alert("お気に入りの更新に失敗しました。時間をおいて再度お試しください。");
    } finally {
      sameVariantRoots.forEach((candidate) => setLoading(candidate, false));
    }
  }

  function init(rootElement) {
    const scope = rootElement || document;
    const roots = scope.matches && scope.matches(SELECTOR)
      ? [scope]
      : scope.querySelectorAll(SELECTOR);

    roots.forEach((root) => {
      if (root.dataset.multilikesInitialized === "true") {
        return;
      }

      root.dataset.multilikesInitialized = "true";

      const button = root.querySelector("[data-multilikes-toggle]");

      if (button) {
        button.addEventListener("click", () => toggle(root));
      }

      warnIfIdsMissing(root);
      refresh(root);
    });
  }

  document.addEventListener("DOMContentLoaded", () => init());
  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail && event.detail.variant;

    if (!variant || !variant.id) {
      return;
    }

    const eventTarget = event.target && event.target.nodeType === 1 ? event.target : document;
    const roots = eventTarget.matches && eventTarget.matches(SELECTOR)
      ? [eventTarget]
      : Array.from(eventTarget.querySelectorAll(SELECTOR));

    roots.forEach((root) => {
      refresh(root, { variantId: variant.id });
    });
  });

  // テーマエディタでセクションが差し替わったときは、新しいボタンに状態を当てる
  document.addEventListener("shopify:section:load", (event) => init(event.target));

  // 戻る・進むでページがそのまま復元されたときは、ほかのページでの追加・解除を反映する
  window.addEventListener("pageshow", (event) => {
    if (event.persisted && config.customerId) {
      applyRecentChanges();
      refreshAll();
    }
  });

  // rememberChange は一覧ページ（multilikes-wishlist-page.js）の削除からも呼ぶ
  window.MultiLikesFavorite = { init, refresh, rememberChange };
})();
